// extracted by mini-css-extract-plugin
export default {"timer":"OrderDeadline_timer__zYuZd","overdue":"OrderDeadline_overdue__oOICa"};